import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './layout.component';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {HeaderComponent} from './header/header.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SideMenuItemComponent} from './side-menu/components/side-menu-item/side-menu-item.component';
import {UserProfileSideMenuComponent} from './user-profile-side-menu/user-profile-side-menu.component';
import {ViewSelectorComponent} from './header/view-selector/view-selector.component';
import {ClickOutsideModule} from '../../shared/directives/click-outside/click-outside.module';
import { UserNotificationComponent } from './header/user-notification/user-notification.component';
import { MomentPipeModule } from '../../shared/pipes/moment/moment-pipe.module';
import { GlobalSearchComponent } from './header/global-search/global-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { StatusModule } from '../../shared/components/status/status.module';
import { EllipsisTooltipModule } from '../../shared/directives/ellipsis-tooltip/ellipsis-tooltip.module';
import { SharedModule } from '../../shared/shared.module';
import { AvatarImageModule } from '../../shared/components/avatar/avatar-image.module';
import { HighlightModule } from '../../shared/common/highlight/highlight.module';
import { StaticlinkNavigationComponent } from './header/staticlink-navigation/staticlink-navigation.component';
import { TooltipModule } from '../../shared/components/tooltip/tooltip.module';
import { OwnerSearchModule } from '../../shared/components/owner-search/owner-search.module';
import { MergeTabsModule } from 'src/app/shared/components/tabs/tabs.module';

@NgModule({
  declarations: [
    LayoutComponent,
    SideMenuComponent,
    HeaderComponent,
    SideMenuItemComponent,
    UserProfileSideMenuComponent,
    ViewSelectorComponent,
    UserNotificationComponent,
    GlobalSearchComponent,
    StaticlinkNavigationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ClickOutsideModule,
    TranslateModule,
    ReactiveFormsModule,
    TooltipModule,
    StatusModule,
    MomentPipeModule,
    TranslateModule,
    EllipsisTooltipModule,
    SharedModule,
    AvatarImageModule,
    HighlightModule,
    OwnerSearchModule,
    MergeTabsModule
  ],
  exports: [
    LayoutComponent,
  ],
})
export class LayoutModule {
}
